export default "__VITE_ASSET__B68$mksM__"